import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api, { setStoredToken } from "../api";
import { useAuth } from "../AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        // Persist the OAuth session_token to localStorage so the axios
        // request interceptor can send it as `Authorization: Bearer …`
        // on subsequent calls. Without this, iOS Safari (and any browser
        // dropping the `session_token` cookie under ITP / cookie
        // partitioning) gets "Not authenticated" on subsequent fetches
        // such as POST /api/subscriptions/checkout.
        if (data?.token) setStoredToken(data.token);
        setUser(data.user);
        // Clean URL fragment and go to dashboard
        window.history.replaceState({}, "", "/dashboard");
        navigate("/dashboard", { replace: true, state: { user: data.user } });
      } catch (e) {
        navigate("/login?error=oauth", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center font-mono text-sm overline" data-testid="auth-callback">
      ESTABLISHING SESSION…
    </div>
  );
}
